import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { User } from "../../models/entities/user";
import { Company } from "../../models/entities/company";

import { ActionIcon, ContentName, WhatsappIcon, Table } from "./style";

type CompanyUsers = {
  user_id: number;
  full_name: string;
};
interface IProps extends RouteComponentProps {
  data: CompanyUsers[];
  profileList: User[] | null;
  company: Company | null;
}

const UserCompanies: React.FC<IProps> = ({
  data,
  history,
  profileList,
  company,
}) => {
  const columns = [
    {
      title: "ID do Usuário",
      dataIndex: "user_id",
      key: "user_id",
      width: "30%",
    },
    {
      title: "Nome",
      dataIndex: "full_name",
      key: "full_name",
      ellipsis: true,
      width: "50%",
      render: (text) => (
        <ContentName>
          <span>{text}</span>
        </ContentName>
      ),
    },
    {
      title: "Perfil",
      dataIndex: "profile",
      key: "profile",
      ellipsis: true,
      width: "50%",
      render: (text) => (
        <ContentName>
          <span>
            {profileList?.find((_profile) => _profile.id === text)?.name}
          </span>
        </ContentName>
      ),
    },
    {
      title: "Ações",
      dataIndex: "more",
      key: "more",
      width: "20%",
      render: (_, record) => (
        <>
          <ActionIcon
            onClick={() => {
              history.push(`/users?userId=${record.user_id}`);
            }}
          />
          {record.phone && record?.country_code ? (
            <a
              href={`https://wa.me/${record?.country_code}${record?.phone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsappIcon />
            </a>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        pagination={false}
        scroll={{ y: 600 }}
        dataSource={data.map((entity) => ({
          key: entity.user_id,
          ...entity,
        }))}
      />
    </>
  );
};

export default withRouter(UserCompanies);
